export default class User {
  public email = '';

  public id = '';

  public isSuperAdmin = '';

  constructor(data: any = {}) {
    this.id = data.id || '';
    this.email = data.email || '';
    this.isSuperAdmin = data.is_super_admin || '';
  }
}
